// 素材列表
export function getMaterialList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/scheduleMediaPageList',
    data
  })
}

// 新增，更新，提交送审
export function saveMaterial(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/addOrUpdate',
    data
  })
}
// 新增，更新，提交送审
export function saveProgrammaticMaterial(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/addOrUpdateProgrammed',
    data
  })
}
// 复制素材
export function copyMaterial(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/copy?id=' + data.id + '&quantity=' + data.quantity
  })
}
// 查询单个素材
export function getMaterialById(params) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/detail',
    params
  })
}
// 启用，暂停，删除映射状态
export function updateMedia(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/operateScheduleMedia',
    data
  })
}
export function operateMaterial(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/operateScheduleMedia',
    data
  }).then(data => {
    return data
  }).catch(e => {
    return {
      isError: true,
      errorMsg: e.message
    }
  })
}

// 文件上传
export function uploadFile(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/uploadMedia',
    data
  })
}

// 文件下载
export function downLoadImgFile(params) {
  return Promise.resolve({
    url: `api/dsp/mediaNew/download?mediaId=${params.mediaId}`
  })
}
// 分页查询
export function getSearchList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/pageList',
    data
  })
}

export function getMediasByOrderId(orderId) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/orderMedias?orderId=' + orderId
  })
}

// 修改素名称
export function updateMediaName(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/mediaNew/updateMediaName',
    data
  })
}
export function getCodeMacroMap(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getCodeMacroMap',
    params
  })
}
// 查询计划单下素材详情 (只展示草稿，待审核，已审核，已测试, 审核不通过的素材)，用于编辑素材
export function scheduleMediaDetails(id) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/scheduleMediaDetails?scheduleId=' + id
  })
}
// 编辑素材
export function scheduleMediaEdit(id) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/scheduleMediaEdit?scheduleId=' + id
  })
}
// 通过广告位id获取广告位信息
export function getSpaceModelById(params) {
  return this.fetch({
    method: 'get',
    url: 'api/admin/space/getSpaceData',
    params
  })
}
// 获取监测商列表
export function getProviderList() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getProviderList'
  })
}

// 获取可用的监测商列表
export function getAvailProviderList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/track/dataList',
    data
  })
}

// 素材媒体方审核
export function cableChannelApprove(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/adCableChannelMedia/submit',
    data
  })
}

export function getCoocaaTrack(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/getOriginTrack',
    data
  })
}

// 牌照方方送审
export function pushLicenseMedia(licenseMediaId) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/licenseMedia/pushMediaToLicense?licenseMediaId=' + licenseMediaId
  })
}

// 获取程序化单创意详情
export function getProgrammaticDetail(id) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/programmedScheduleMedias?scheduleId=' + id
  })
}

// 第三方素材创意分页列表
export function getThirdMaterialList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/programmedPageList',
    data
  })
}

// 删除第三方素材创意
export function removeThirdMaterialList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/removeProgrammedMedia',
    data
  })
}

// 获取定点监测时间选项
export function getPointList() {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/getAllowedPoints'
  }).then((res) => {
    if (!res) {
      return
    }
    const pointList = []
    for (const key in res) {
      pointList.push(res[key])
    }
    pointList.sort((prev, next) => prev - next)
    return pointList.map((item) => {
      return {
        value: `${item}`,
        label: `${item}`,
      }
    })
  })
}
